"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoRadioQuestionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var journey_model_1 = require("@athena-portal/journey-model");
var FalconSelectQuestionWidgetBase_1 = require("../FalconSelectQuestionWidgetBase");
var InfoQuestionWrapper_1 = require("../../components/infoQuestion/InfoQuestionWrapper");
var journey_services_1 = require("@athena-portal/journey-services");
var journey_services_2 = require("@ferry/journey-services");
var InfoRadioQuestionWidget = /** @class */ (function (_super) {
    __extends(InfoRadioQuestionWidget, _super);
    function InfoRadioQuestionWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        return _this;
    }
    InfoRadioQuestionWidget.prototype.render = function () {
        var label = this.props.question.label ? this.props.question.label : this.renderHtml(this.getSetting("labelHtml"));
        var info = this.renderHtml(this.getSetting("infoHtml"));
        return ((0, jsx_runtime_1.jsxs)(InfoQuestionWrapper_1.InfoQuestionWrapper, { label: label, infoType: this.getSetting("infoType"), info: info, infoTitle: this.getSetting("infoTitle"), className: this.getSetting("cssClass"), hideInfoButton: this.isMtaAndDisabled(), children: [this.renderInputField(), this.renderValidationResult()] }));
    };
    InfoRadioQuestionWidget.prototype.renderInputField = function () {
        var _this = this;
        var _a, _b;
        var radioButtons = [];
        // Setting whether to disable field is taken either from condition name specified as "disabled",
        // or from inputDisabled boolean setting as usual
        var radioType = this.getSetting("radioType");
        var disabled = this.getSetting("disabled");
        this.disabled = disabled
            ? journey_services_1.ConditionEvaluator.evaluateCondition(this.props.journey.displayConditions, disabled, this.props.interaction)
            : this.getSetting(journey_services_2.INPUT_DISABLED_SETTING, false);
        if (this.state.lookupValues) {
            var validationErrors_1 = (_b = (_a = this.props.validations[this.props.question.name]) === null || _a === void 0 ? void 0 : _a.errors) !== null && _b !== void 0 ? _b : [];
            this.state.lookupValues.forEach(function (v, i) {
                radioButtons.push(_this.getRadioButton(v, i, validationErrors_1, radioType));
            });
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "form-group mb-0", id: this.props.question.name, children: (0, jsx_runtime_1.jsx)("div", { className: "input-group width-auto pb-0 ".concat(radioType == "radio" ? 'd-block' : ''), role: "group", children: radioButtons }) }));
    };
    InfoRadioQuestionWidget.prototype.isChecked = function (id) {
        return (id === "".concat(this.bindFromField(this.props.question.interactionField)));
    };
    InfoRadioQuestionWidget.prototype.getRadioButton = function (v, i, validationErrors, radioType) {
        if (radioType == "radio") {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "custom-control margin-bottom-20-padding-left-0 d-flex", onClick: this.executeNativeEvent, children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-radiobutton ".concat(validationErrors.length > 0 ? "is-invalid" : ""), type: "radio", name: this.props.question.name, id: this.props.question.name + v.id, value: v.id, checked: this.isChecked(v.id), onChange: this.handleOnChangeEvent, onBlur: this.handleOnBlurEvent, disabled: this.disabled }), (0, jsx_runtime_1.jsx)("label", { className: "checkbox-label label-bg-transparent", htmlFor: this.props.question.name + v.id, children: this.renderHtml(v.value) })] }, i));
        }
        else {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", onClick: this.executeNativeEvent, children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input ".concat(validationErrors.length > 0 ? "is-invalid" : ""), type: "radio", name: this.props.question.name, id: this.props.question.name + v.id, value: v.id, checked: this.isChecked(v.id), onChange: this.handleOnChangeEvent, onBlur: this.handleOnBlurEvent, disabled: this.disabled }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: this.props.question.name + v.id, children: this.renderHtml(v.value) })] }, i));
        }
    };
    InfoRadioQuestionWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "labelHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "infoType", type: journey_model_1.TypeDescriptions.String },
            { name: "infoTitle", type: journey_model_1.TypeDescriptions.String },
            { name: "infoHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "disabled", type: journey_model_1.TypeDescriptions.Number },
            { name: journey_services_2.INPUT_DISABLED_SETTING, type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        __metadata("design:paramtypes", [Object])
    ], InfoRadioQuestionWidget);
    return InfoRadioQuestionWidget;
}(FalconSelectQuestionWidgetBase_1.FalconSelectQuestionWidgetBase));
exports.InfoRadioQuestionWidget = InfoRadioQuestionWidget;
//# sourceMappingURL=InfoRadioQuestionWidget.js.map